// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import store from '@/store/store'// 引入store
import { Vue } from '@/assets/config/config.js'
import App from './App'
import router from './router/index.js'
import '@/assets/css/reset.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { Loading } from 'element-ui';
import * as echarts from "echarts";
import permissionInit from './router/permission.js'
import { commonData } from './router/commonData.js'
import { setCookie, getCookie, delCookie, delAllCookie } from '@/assets/js/cookie.js'
import { formatNum, date_compatible } from '@/assets/js/common.js'
Vue.prototype.$formatNum = formatNum
Vue.prototype.$date_compatible = date_compatible
Vue.prototype.$cookie = { setCookie, getCookie, delCookie, delAllCookie }
Vue.prototype.$commonData = commonData
import htmlToPdf from '@/assets/js/htmlToPdf.js'
import statementToPdf from '@/assets/js/statementToPdf.js'
Vue.use(htmlToPdf)
Vue.use(statementToPdf)
import { UxGrid, UxTableColumn } from 'umy-ui'
// import 'umy-ui/lib/theme-chalk/index.css';
Vue.use(UxGrid);
Vue.use(UxTableColumn);
import Print from '@/plugs/print'
Vue.use(Print)
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.$loadingConfig = {
  lock: true,
  text: '加载中...',
  spinner: 'el-icon-loading',
  background: 'rgba(255, 255, 255, 0.3)'
}
import selfBack from '@/components/assembly/back.vue'
Vue.component('self-back', selfBack)

// 登录拦截
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title : '';
  if (to.meta.isLogin) {
    if (!Boolean(getCookie('isLogin'))) {
      next('/login')
    } else {
      next();
    }
  } else {
    if (!to.name) {
      //name不存在 解决未登录跳转到页面 而页面未注册的问题
      if (!Boolean(getCookie('isLogin'))) {
        next('/login')
      } else {
        next();
      }
    } else {
      next();
    }
  }
});
// 权限控制--------------------------------------------------------------------------------
// let loadingInstance = Loading.service({
//   lock: true,
//   spinner: 'el-icon-loading',
//   background: 'rgba(255, 255, 255, 0.3)'
// });
permissionInit(() => {
  new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    data: {
    },
    mounted () {
      // this.$nextTick(()=>{
      //   loadingInstance.close()
      // })
    },
  })
})


// WEBPACK FOOTER //
// ./src/main.js